import { useEffect } from 'react'
import type { RefObject } from 'react'

/**
 * Fecha menus e popovers ao clicar fora ou apertar Esc.
 * Usa `pointerdown` para reagir antes do clique disparar em outro elemento.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  onOutside: () => void,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return

    function handlePointer(event: PointerEvent) {
      const el = ref.current
      if (el && !el.contains(event.target as Node)) onOutside()
    }
    function handleKey(event: KeyboardEvent) {
      if (event.key === 'Escape') onOutside()
    }

    document.addEventListener('pointerdown', handlePointer)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('pointerdown', handlePointer)
      document.removeEventListener('keydown', handleKey)
    }
  }, [ref, onOutside, enabled])
}
